import { desktopBreakpoint, tabletBreakpoint } from 'react-components'
import styled from 'styled-components'

export const SkeletonGridContainer = styled.div`
    display: flex;
    gap: 1.25rem;
    width: 100%;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    margin: 1rem 1rem 0;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
        display: none;
    }

    > * {
        flex: 0 0 48.8%;
        scroll-snap-align: start;
    }

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        margin: 1rem 1.5rem 0;
        > * {
            flex: 0 0 33.43%;
        }
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        overflow: visible;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 1.5rem;
        margin: 1.25rem 0 0;

        > * {
            flex: none;
            width: auto;
        }
    }
`

export const SkeletonContainer = styled.div`
    display: flex;
    flex-direction: column;
    background: ${({ theme }) => theme.colors.white};
    border-radius: 1rem;
    width: 100%;
`

export const ImagePlaceholder = styled.div`
    position: relative;
    width: 200px;
    height: 150px;
    border-radius: 1rem;
    overflow: hidden;
    background: #f6f7f8;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        width: 282px;
        height: 187px;
    }
`

const BadgePlaceholderBase = styled.div`
    position: absolute;
    border-radius: 0.75rem;
    background: #f6f7f8;
`

export const BadgePlaceholderLeft = styled(BadgePlaceholderBase)`
    top: 1rem;
    left: 1rem;
    width: 4.5rem;
    height: 1.25rem;
`

export const BadgePlaceholderRight = styled(BadgePlaceholderBase)`
    top: 1rem;
    right: 1rem;
    width: 1.25rem;
    height: 1.25rem;
`

export const Content = styled.div`
    padding: 0.75rem 0 0;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`

export const TopRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
`

export const RatingPlaceholder = styled.div`
    display: flex;
    align-items: center;
    gap: 0.25rem;
`

const LineBase = styled.div`
    border-radius: 0.25rem;
    background: #f6f7f8;
`

export const TitleLine = styled(LineBase)`
    width: 40%;
    height: 0.875rem;
`

export const RatingIconLine = styled(LineBase)`
    width: 1rem;
    height: 1rem;
`

export const RatingTextLine = styled(LineBase)`
    width: 1.5rem;
    height: 0.75rem;
`

export const DescriptionLine = styled(LineBase)<{ $width?: string; $height?: string }>`
    width: ${({ $width }) => $width || '100%'};
    height: ${({ $height }) => $height || '1rem'};
`
